module.exports = __webpack_public_path__ + "static/media/badge_ptrnC.0a5065dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badge_ptrnC.png
// module id = 1621
// module chunks = 1